import { owcTheme } from '@one/design-tokens/js/regular/navify/light';
import styled from 'styled-components';

export const SearchErrorLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: ${owcTheme['one-spacing-base-4']};
`;
